<template>
<v-container fluid>
  <v-col cols="3" class="text-center">
                   <v-btn
                  large
                  color="success"
                   @click="getReportesByIdEncuestaPregunta"
                >
                Descargar Resultados
                <v-icon class="mr-2">download_for_offline</v-icon>          
                </v-btn>
          </v-col>    
</v-container>
</template>

<script>
import {getReportesByIdEncuestaPregunta} from "@/api";

export default {
  name: "ResultadosPregunta",
  components: {
   
  },
  props: {
      idEncuesta: {
      type: Number,
      required: true,
    },
    idPregunta: {
      type: Number,
      required: true,
    },
     fecha: {
      type: String,
      required: true,
    }, 
     fecha2: {
      type: String,
      required: true,
    }, 
      mostrarTodos:{
      type: Boolean,
      required:true
    },
     idCampus: {
      type: String,
      required: true,
    }, 
     idDivision: {
      type: String,
      required: true,
    },
  },
  data () {
    return {
      loading: true,
      snackbar: false,
      snackbarColor: '',
      snackbarTexto: '',
      headers: [
        { align: "center", text: "Respuestas", value: "textoRespuesta" },
        { align: "left", text: "Cantidad", value: "num" }
    
      ],
      items: [],
      itemsFilter: [],
      search: "",
      dialog: false,
      itemSelected: {},
      itemDelete: {},
      dialogEliminar:  false,
      loadingEliminar: false,
    };
  },
  computed: {},
  watch: {
    flagReload: {
      handler (newValue, oldValue) {
       // this.obtenerRoles();
			},
    },
  },
  mounted () {
    
  },
  methods: {
    async getReportesByIdEncuestaPregunta () {
      var self = this;
      self.loading = true;
      self.items = [];
      self.itemsFilter = [];
      self.snackbarError = false;
      self.textoError = "";

      try {
          let response="";
    // response= await getReportesByIdEncuestaPregunta(this.idEncuesta, this.idPregunta, this.fecha, this.fecha2);
    

    if(self.mostrarTodos==true){
           if(self.idCampus==null){
             response= await getReportesByIdEncuestaPregunta(this.idEncuesta, this.idPregunta, '', '', '','');
             
           }
           else{
        if(self.idCampus!=null&&self.idDivision==null){
           response= await getReportesByIdEncuestaPregunta(this.idEncuesta, this.idPregunta, '', '', this.idCampus,'');
         
        }
        else{
        if(self.idCampus!=null&&self.idDivision!=null){
          response= await getReportesByIdEncuestaPregunta(this.idEncuesta, this.idPregunta, '', '', this.idCampus,this.idDivision);
        }
        }
        }
        }
        else{
           if(self.idCampus==null){
             response= await getReportesByIdEncuestaPregunta(this.idEncuesta, this.idPregunta, this.fecha, this.fecha2, '','');
           }
             else{
        if(self.idCampus!=null&&self.idDivision==null){
          response= await getReportesByIdEncuestaPregunta(this.idEncuesta, this.idPregunta, this.fecha, this.fecha2, this.idCampus,'');
        
        }
        else{
        if(self.idCampus!=null&&self.idDivision!=null){
         response= await getReportesByIdEncuestaPregunta(this.idEncuesta, this.idPregunta, this.fecha, this.fecha2, this.idCampus,this.idDivision); 
        }
        }
        }
          }
    
    const url = URL.createObjectURL(new Blob([response.data]))
    const link = document.createElement('a')
    link.href = url
    link.setAttribute(
      'download',
      `ReportePregunta.xlsx`
    )
    document.body.appendChild(link)
    link.click()       
              self.loading = false;
            
      } catch (e) {
        self.loading = false;
        self.snackbarTexto = "DataTableEncuestaRoles: " + e;
        self.snackbarColor = "error";
        self.snackbar = true;
      }
    },

  }
};
</script>